module.exports = __webpack_public_path__ + "static/media/banner-home.37fa649d.jpg";